function comparator(val, scaler) {
    return function (a, b) { return scaler(a[val]) - scaler(b[val]); };
}
export default comparator;
